<template>
  <div class="autocomplete">
    <v-autocomplete
      v-model="selectedUser"
      :label="label"
      :items="serviceProviderUsersForAppointment"
      :loading="serviceProviderUsersForAppointmentLoading"
      :disabled="disabled"
      :rules="rules"
      :search-input.sync="search"
      :no-data-text="noDataText"
      :hide-no-data="hideNoData"
      prepend-inner-icon="mdi-magnify"
      item-text="name"
      item-value="id"
      return-object
      clearable
      outlined
      @change="handleSelection"
    >
      <template v-slot:item="{ item }">
        <div class="py-2">
          <p class="body-2 mb-0">{{ item.name }}</p>
          <p class="caption grey--text mb-0">{{ item.username }}</p>
          <p class="caption grey--text mb-0" v-if="item.branch">{{ item.branch.name }}</p>
        </div>
      </template>
    </v-autocomplete>

    <v-progress-circular
      v-show="serviceProviderUsersForAppointmentLoading"
      class="autocomplete-loading"
      color="primary"
      width="1.5"
      size="13"
      indeterminate
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ServiceProviderUserSelect',

  props: {
    value: { type: String, default: null },
    label: { type: String, default: 'Selecione um membro da equipe' },
    rules: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    visitType: { type: String, default: null },
  },

  data() {
    return {
      selectedUser: null,
      search: null,
      timer: null,
    }
  },

  computed: {
    ...mapGetters([
      'serviceProviderUsersForAppointment',
      'serviceProviderUsersForAppointmentLoading',
    ]),

    hasMinSearch() {
      return !!this.search && this.search.trim().length >= 2
    },

    hideNoData() {
      // só mostra "sem resultados" quando já digitou o mínimo e não está carregando
      return !this.hasMinSearch || this.serviceProviderUsersForAppointmentLoading
    },

    noDataText() {
      if (!this.hasMinSearch) return this.$t('common.typeToSearch') // "Digite para pesquisar"
      return this.$t('appointment.formCreate.errors.noHostFound') // "Não existe host..."
    },
  },

  methods: {
    ...mapActions(['searchServiceProviderUsersForAppointment']),
    ...mapMutations(['setServiceProviderUsersForAppointment']),

    handleSelection(user) {
      const id = user?.id || null

      this.$emit('input', id)
      this.$emit('selected', user || null)
    },

    triggerSearch(term) {
      if (!this.visitType) return

      if (!term || term.length < 2) {
        clearTimeout(this.timer)
        this.setServiceProviderUsersForAppointment([])
        return
      }

      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.searchServiceProviderUsersForAppointment({
          name: term,
          visitType: this.visitType,
        })
      }, 500)
    },

    clearAll() {
      clearTimeout(this.timer)
      this.selectedUser = null
      this.search = null
      this.setServiceProviderUsersForAppointment([])
      this.$emit('input', null)
    },
  },

  watch: {
    search(term) {
      if (term === null || term === undefined || term === '') {
        clearTimeout(this.timer)
        this.setServiceProviderUsersForAppointment([])
        return
      }
      this.triggerSearch(term)
    },

    visitType: {
      handler() {
        this.clearAll()
      },
      immediate: true,
    },

    value: {
      handler(val) {
        if (!val) {
          this.selectedUser = null
          return
        }
        const found = this.serviceProviderUsersForAppointment?.find(u => u.id === val)
        if (found) this.selectedUser = found
      },
    },
  },

  beforeDestroy() {
    clearTimeout(this.timer)
  },
}
</script>

<style scoped>
.autocomplete {
  position: relative;
}
.autocomplete-loading {
  position: absolute;
  top: 28px;
  right: 73px;
  transform: translateY(-50%);
}
</style>
